import * as React from 'react';

interface FileSpaceCardTitleSection {
    title: string;
    description?: string;
}

export default function FileSpaceCardTitleSection(props: FileSpaceCardTitleSection) {
    let description = props.description ?
        <span>{props.description}</span> : 
        null;
    return (
        <h2>
            <em className="wrapWord">{props.title}</em>
            {description}
        </h2>
    );
}



// WEBPACK FOOTER //
// ./src/webportal/components/common/filespaceCardComponents/FilespaceCardTitleSection.tsx